import { render, staticRenderFns } from "./RequestMoreBandwidthDialog.vue?vue&type=template&id=43744c69"
import script from "./RequestMoreBandwidthDialog.vue?vue&type=script&lang=ts"
export * from "./RequestMoreBandwidthDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43744c69')) {
      api.createRecord('43744c69', component.options)
    } else {
      api.reload('43744c69', component.options)
    }
    module.hot.accept("./RequestMoreBandwidthDialog.vue?vue&type=template&id=43744c69", function () {
      api.rerender('43744c69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialogs/RequestMoreBandwidthDialog.vue"
export default component.exports